module.exports = __webpack_public_path__ + "static/media/bf3731ee-64fe-49c1-b8a6-a4edbff3c74a.947936ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/bf3731ee-64fe-49c1-b8a6-a4edbff3c74a.svg
// module id = 92
// module chunks = 0